module.exports = __webpack_public_path__ + "img/sculpt3_thumb.a865dec3.jpg";